<template>
  <div :class="['node', { isNodeActive }]" @dblclick.stop>
    <div class="header">
      <i class="node__close el-icon-close" @click="closeNode"></i>

      <el-tooltip
        :open-delay="300"
        effect="light"
        :content="statusName[calcStatus]"
        placement="top"
      >
        <i :class="[`node__status ${calcStatus}`]"></i>
      </el-tooltip>
      <div class="node__mask" v-show="!isNodeActive"></div>
      <el-row type="flex" class="title">
        <i
          :class="
            type === 'data' ? 'editor-node-icon data' : 'editor-node-icon calc'
          "
        />
        <div class="title-text">{{ nodesName[node.name] }}</div>
      </el-row>
      <el-row
        type="flex"
        justify="space-between"
        class="controls"
        align="middle"
      >
        <div class="column">
          <div class="inputs" v-for="input in header.inputs" :key="input.id">
            <socket
              v-socket:input="input"
              type="input"
              :socket="input.socket"
              :used="input.connections.length > 0"
            />
            <div class="input-title" v-show="!input.showControl()">
              {{ input.name }}
            </div>
            <div
              class="input-control"
              v-show="input.showControl()"
              v-control="input.control"
            />
          </div>
        </div>
        <div class="column">
          <div
            class="outputs"
            v-for="output in header.outputs"
            :key="output.id"
          >
            <div class="output-title">
              {{ output.name }}
            </div>
            <socket
              v-socket:output="output"
              type="output"
              :socket="output.socket"
              :used="output.connections.length > 0"
            />
          </div>
        </div>
      </el-row>
    </div>
    <div class="content">
      <el-row type="flex" justify="start" class="controls" align="middle">
        <div class="column">
          <div class="inputs" v-for="input in body.inputs" :key="input.id">
            <socket
              v-socket:input="input"
              type="input"
              :socket="input.socket"
              :used="input.connections.length > 0"
            />
            <div class="input-title" v-show="!input.showControl()">
              {{ input.name }}
            </div>
            <div
              class="input-control"
              v-show="input.showControl()"
              v-control="input.control"
            />
          </div>
          <div
            class="control"
            v-for="control in body.controls.primary"
            :key="control.id"
            style="text-align: center;"
            :style="{
              width: control.parent.width - 2 * control.margin,
              height: control.height
            }"
            v-control="control"
          />
          <el-collapse
            class="r-collapse"
            v-model="openSecondary"
            @change="toggleSettings"
            v-show="body.controls.secondary.length"
          >
            <el-collapse-item title="Дополнительные параметры" name="1">
              <div
                class="control"
                v-for="control in body.controls.secondary"
                :key="control.id"
                style="text-align: center;"
                :style="{
                  width: control.parent.width - 2 * control.margin,
                  height: control.height
                }"
                v-control="control"
            /></el-collapse-item>
          </el-collapse>
        </div>
      </el-row>
      <el-row type="flex" justify="end" class="controls" align="middle">
        <div class="column output-block">
          <div
            class="control"
            v-for="control in body.controls.output"
            :key="control.id"
            style="text-align: center;"
            :style="{
              width: control.parent.width - 2 * control.margin,
              height: control.height
            }"
            v-control="control"
          />
          <div class="outputs" v-for="output in body.outputs" :key="output.id">
            <div class="output-title">
              {{ output.name }}
            </div>
            <socket
              v-socket:output="output"
              type="output"
              :socket="output.socket"
              :used="output.connections.length > 0"
            />
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import VueRender from "rete-vue-render-plugin";
import Socket from "../../sockets/socket";

const nodesName = {
  DemandMatrix: "Матрица корреспонденций",
  SkimMatrix: "Матрица затрат",
  STA: "STA"
};
const statusName = {
  calculation: "В процессе расчёта",
  default: "Не рассчитан",
  error: "Ошибка",
  success: "Рассчитан"
};

export default {
  mixins: [VueRender.mixin],
  props: ["comp", "type"],
  data() {
    return {
      header: {
        inputs: [],
        outputs: []
      },
      body: {
        controls: {
          primary: [],
          secondary: [],
          output: []
        },
        inputs: [],
        outputs: []
      },
      isActive: true,
      calcStatus: "default",
      openSecondary: [],

      statusName,
      nodesName
    };
  },
  components: {
    Socket
  },
  computed: {
    isNodeActive() {
      return this.node.data.switch;
    }
  },
  methods: {
    closeNode() {
      this.editor.removeNode(this.node);
    },
    toggleSettings() {
      const update = setInterval(() => updateConnections(this), 5);

      function updateConnections(state) {
        state.editor.view.updateConnections({ node: state.node });
      }
      setTimeout(function() {
        clearInterval(update);
      }, 400);
    }
  },
  async created() {
    const existSchema = this.comp.schema;
    if (
      existSchema &&
      existSchema.nodes[this.node.id] &&
      existSchema.nodes[this.node.id].data.switch
    ) {
      this.calcStatus = "calculation";
    }

    this.inputs().forEach(e => {
      switch (e.key) {
        case "calculation-input":
          this.header.inputs.push(e);
          break;
        default:
          this.body.inputs.push(e);
          break;
      }
    });

    this.outputs().forEach(e => {
      switch (e.key) {
        case "calculation-output":
          this.header.outputs.push(e);
          break;
        default:
          this.body.outputs.push(e);
          break;
      }
    });

    this.controls().forEach(e => {
      if (e.key === "id" || e.key === "demandId" || e.key === "staId") {
        this.body.controls.output.push(e);
      } else if (e.props.secondary) {
        this.body.controls.secondary.push(e);
      } else {
        this.body.controls.primary.push(e);
      }
    });
  }
};
</script>

<style lang="scss" src="./node.scss"></style>
